import { useState, useCallback } from 'react';

/**
 * Phonics 通用导航 Hook
 * 被 PhonicsAtoZ 和 PhonicsLt 共用
 */
export function usePhonicsNavigation(STEPS) {
  const [currentStep, setCurrentStep] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const goNext = useCallback(() => {
    setCurrentStep((s) => Math.min(s + 1, STEPS.length - 1));
  }, [STEPS.length]);

  const goPrev = useCallback(() => {
    setCurrentStep((s) => Math.max(s - 1, 0));
  }, []);

  const toggleFullscreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => setIsFullscreen(true)).catch(() => {});
    } else {
      document.exitFullscreen().then(() => setIsFullscreen(false)).catch(() => {});
    }
  }, []);

  const isFirst = currentStep === 0;
  const isLast = currentStep === STEPS.length - 1;

  return { currentStep, setCurrentStep, isFullscreen, goNext, goPrev, toggleFullscreen, isFirst, isLast };
}
